module.exports = __webpack_public_path__ + "static/media/news-med-cert-scanner.cc0a1083.png";